export default __webpack_public_path__ + "static/redhat-crw-ss-703c2d37e15a36d9c4132818514e5fb3.png";